document.addEventListener("DOMContentLoaded", (event) => {
  const UPSSELL_LIMIT = 3;

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function getRecommendations(productId) {
    const res = await fetch(
      `/recommendations/products.json?product_id=${productId}&limit=4&intent=related`
    );
    const data = await res.json();
    return data.products || [];
  }

  function filterProducts(products, cart) {
    return products.filter(product => {
      const alreadyInCart = cart.items.some(
        item => item.product_id === product.id
      );

      const hasAvailableVariant = product.variants.some(
        v => v.available
      );

      return !alreadyInCart && hasAvailableVariant;
    });
  }

  async function resolveUpsells(cart) {
    for (const item of cart.items) {
      const products = await getRecommendations(item.product_id);
      const validProducts = filterProducts(products, cart);

      if (validProducts.length) {
        if(validProducts.length > UPSSELL_LIMIT) {
          return validProducts.slice(0, UPSSELL_LIMIT);
        }
        
        return validProducts;
      }
    }
    return [];
  }

  function renderUpsells(products) {
    const container = document.querySelector('#cart-upsell');
    if (!container) return;

    if (!products.length) {
      container.innerHTML = '';
      container.style.display = 'none';
      return;
    }

    container.style.display = 'block';
    container.innerHTML = `
      <div class="upsell">
        <h2 class="upsell-title">Farm Customer Favorites</h2>
        <div class="carousel">
            <button class="carousel-btn prev" aria-label="Previous">‹</button>
            <div class="carousel-window">
                <div class="carousel-track">
        ${products.map(product => {
          const variant = product.variants.find(v => v.available);

          return `
                <!-- Slide -->
                <div class="carousel-slide">
                    <a href="${product.url}">
                        <img
                        src="${product.featured_image}"
                        alt="${product.title}"
                        />
                    </a>
                    <div class="upcart-internal-component-upsell-tile__info upcart-public-component-upsell-tile__info">
                        <a href="${product.url}" class="upcart-internal-component-upsell-tile__title-link upcart-public-component-upsell-tile__title-link">
                            <h3 class="upcart-internal-component-upsell-tile__title upcart-internal-style__title-wrapped upcart-public-component-upsell-tile__title">${product.title}</h3>
                        </a>
                        <div class="upcart-internal-component-upsell-tile__price-row upcart-public-component-upsell-tile__price-row">
                            <span class="upcart-internal-component-upsell-tile__price upcart-public-component-upsell-tile__price" data-upcart-chunk="upsell-new-price">$${(product.price / 100).toFixed(2)}</span>
                        </div>
                        <div class="upcart-internal-component-upsell-tile__variant-row upcart-public-component-upsell-tile__variant-row" data-internal-properties="addLoading=false">
                            <button type="button" data-variant-id="${variant.id}" class="upcart-internal-component__button upcart-public-component__button">Add</button>
                        </div>
                    </div>
                </div>
          `
        }).join('')}
      </div>
                    </div>

                    <button class="carousel-btn next" aria-label="Next">›</button>
                </div>
            </div>
    `;
  }

  function getCartDrawerSections() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.getSectionsToRender !== 'function') return [];

    return cartDrawer.getSectionsToRender().map(section => section.id);
  }

  async function addUpsellToCart(button) {
    if (button.dataset.adding === 'true') return;

    const variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    button.dataset.adding = 'true';
    button.disabled = true;

    try {
      const sections = getCartDrawerSections();
      const payload = {
        id: variantId,
        quantity: 1,
      };

      if (sections.length) {
        payload.sections = sections;
        payload.sections_url = window.location.pathname;
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
      });
      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(result.description || 'Upsell product could not be added.');
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer || typeof cartDrawer.renderContents !== 'function' || !result.sections) {
        throw new Error('Cart drawer sections were not returned.');
      }

      cartDrawer.renderContents(result);
      await initUpsell();
    } catch (error) {
      console.error('[Upsell] Add to cart failed', error);
      if (button.isConnected) {
        button.disabled = false;
        delete button.dataset.adding;
      }
    }
  }

  function bindAddToCart() {
    const addTocartBtns = document.querySelectorAll('.upcart-internal-component__button.upcart-public-component__button');

    if(addTocartBtns.length === 0) return;

    addTocartBtns.forEach((button) => {
      button.addEventListener('click', () => addUpsellToCart(button));
    });
  }

  async function initUpsell() {
    const cart = await getCart();

    // Empty cart -> Clear
    if (!cart.items.length) {
      renderUpsells([]);
      return;
    }

    const upsells = await resolveUpsells(cart);
    if(!upsells || (upsells && upsells.length === 0)) return;
    renderUpsells(upsells);
    initUpsellSlider();
    bindAddToCart();

    document.querySelectorAll('cart-remove-button button').forEach((button) => {
      button.addEventListener('click', function(e){
        console.log('removing')
        document.dispatchEvent(
          new CustomEvent('cart:changed', {
            bubbles: true
          })
        );
      });
    });
  }

    function initUpsellSlider() {
        const track = document.querySelector('.carousel-track');
        const slides = document.querySelectorAll('.carousel .carousel-track .carousel-slide');
        const prev = document.querySelector('.carousel-btn.prev');
        const next = document.querySelector('.carousel-btn.next');

        if (!track || slides.length <= 1) return;

        let index = 0;

        function update() {
            track.style.transform = `translateX(-${index * 100}%)`;
        }

        prev.addEventListener('click', () => {
            index = index === 0 ? slides.length - 1 : index - 1;
            update();
        });

        next.addEventListener('click', () => {
            index = index === slides.length - 1 ? 0 : index + 1;
            update();
        });
    }

    document.addEventListener('submit', function (event) {
      const form = event.target;
      console.log('Adding to cart')

        if (form.action && form.action.includes('/cart/add')) {
          console.log('Added to cart')
          document.dispatchEvent(
            new CustomEvent('cart:changed', {
              bubbles: true
            })
          );
        }
    });
    
    document.addEventListener('cart:changed', function (event) {
      setTimeout(() => {
        initUpsell();
      }, 600)
    });

  // Initialize  
  initUpsell();
});
